import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import { Nav } from "./components/Nav";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import Landing from "./pages/Landing";
import Booking from "./pages/Booking";
import Account from "./pages/Account";
import ManageBooking from "./pages/ManageBooking";
import Admin from "./pages/Admin";
import Legal from "./pages/Legal";
import { setLenis, scrollToTop, scrollToIdWhenReady } from "./lib/scroll";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return scrollToIdWhenReady(hash);
    scrollToTop();
  }, [pathname, hash]);
  return null;
};

// Oculta el menú/footer del sitio dentro del panel interno (/admin).
const SiteChrome = ({ children }) => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return children;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    setLenis(lenis);
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      setLenis(null);
      lenis.destroy();
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollManager />
            <SiteChrome>
              <Nav />
            </SiteChrome>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/book" element={<Booking />} />
              <Route path="/account" element={<Account />} />
              {/* Enlace del recibo: deja cambiar la clase sin cuenta ni contraseña. */}
              <Route path="/reserva/:id" element={<ManageBooking />} />
              <Route path="/booking/:id" element={<ManageBooking />} />
              <Route path="/admin" element={<Admin />} />
              {/* URL fija del contrato: el estudio la enlaza en su solicitud de licencia. */}
              <Route path="/terms" element={<Legal docKey="terms" />} />
              <Route path="/privacy" element={<Legal docKey="privacy" />} />
            </Routes>
            <SiteChrome>
              <>
                <Footer />
                <WhatsAppButton />
              </>
            </SiteChrome>
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
